module.exports = __webpack_public_path__ + "img/people-arrows-left-right.a48c5bf9.svg";